import type { Portal } from '@hcc/types';

export interface LoginCopy {
  title: string;
  subtitle: string;
  /** Who the page tells a stuck user to contact, e.g. "your induction coordinator". */
  helpContact: string;
  /** Whether the personal-email one-time-code panel is offered at all. */
  offerOtp: boolean;
}

/**
 * Portal-specific wording for the shared sign-in page. The training portal
 * is for existing staff, who all hold a Corrigenda 365 account, so it is
 * SSO-only and never mentions onboarding: the one-time code is the
 * pre-start path for new starters who do not yet have a work account, and
 * offering it here would only invite the wrong people to try it.
 */
export function loginCopy(portal: Portal): LoginCopy {
  if (portal === 'training') {
    return {
      title: 'Corrigenda Training',
      subtitle: 'Sign in with your Corrigenda Microsoft account to see your training.',
      helpContact: 'HR or your line manager',
      offerOtp: false,
    };
  }
  return {
    title: 'Welcome to Corrigenda',
    subtitle: 'Sign in to continue',
    helpContact: 'your induction coordinator',
    offerOtp: true,
  };
}
